var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2057 70V23.3334L53.7889 0V17.9166L69.6225 27.0834C70.2475 27.4998 70.2475 28.3334 69.6225 28.5418L50.8725 39.3752C50.2475 39.7916 49.6225 39.5834 49.2057 39.3752L30.4557 28.5418C29.8307 28.3334 29.8307 27.2918 30.4557 27.0834L46.2891 17.9166V0L5.66406 23.3334V70L21.0807 61.0416V42.7082C21.0807 42.0832 21.9141 41.6668 22.3307 41.875L41.0807 52.7084C41.7057 53.125 41.9141 53.5418 41.9141 54.1668V75.8332C41.9141 76.4582 41.0807 76.8752 40.6641 76.6666L24.8309 67.5L9.41406 76.4584L49.8307 100L90.2475 76.6666L74.8307 67.7082L58.9975 76.8752C58.3725 77.2916 57.7475 76.8752 57.7475 76.0416V54.375C57.7475 53.75 58.1639 53.125 58.5807 52.9166L77.3309 42.0832C77.9557 41.6668 78.5807 42.0832 78.5807 42.9166V61.25L94.2057 70Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8306 100L90.2474 76.6667L74.8306 67.7083L58.9974 76.8753C58.3724 77.2917 57.7474 76.8753 57.7474 76.0417V54.3751C57.7474 53.7501 58.1638 53.1251 58.5806 52.9167L77.3308 42.0833C77.9556 41.6669 78.5806 42.0833 78.5806 42.9167V61.2501L93.9972 70.2085V23.3335L49.8306 48.9585V100Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7891 0V17.9166L69.6225 27.0834C70.2475 27.4998 70.2475 28.3334 69.6225 28.5418L50.8725 39.3752C50.2475 39.7916 49.6225 39.5834 49.2057 39.3752L30.4557 28.5418C29.8307 28.3334 29.8307 27.2918 30.4557 27.0834L46.2891 17.9166V0L5.66406 23.3334L49.8307 48.9584L93.9973 23.3334L53.7891 0Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8725 76.8751L25.0389 67.7083L9.62227 76.6667L50.0391 100V48.9585L5.66406 23.3335V70.0001L21.0807 61.0417V42.7083C21.0807 42.0833 21.9141 41.6669 22.3307 41.8751L41.0807 52.7085C41.7057 53.1251 41.9141 53.5419 41.9141 54.1669V75.8333C42.1225 76.6667 41.4975 77.2917 40.8725 76.8753V76.8751Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.99ed2305e29393c85310f27161611c86.svg";
export { ForwardRef as ReactComponent };